import { ChannelBinding } from 'modules/channels/types';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { GhostButton } from 'ui/button';
import { Close16 } from 'ui/icons';
import { BaseOption, BasicSelect } from 'ui/selects';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const InputRow = styled.div`
  display: grid;
  gap: ${spacing.base};
  grid-template-columns: 1fr ${pxToRem(100)} auto;

  &:not(:first-child) {
    margin-top: ${spacing.half};
  }
`;

const StyledFormField = styled(FormField)`
  & + & {
    margin-top: 0;
  }
`;

const StyledSelect = styled(BasicSelect)`
  display: block;
`;

type Props = {
  errors: { [key: string]: string };
  hasRemove: boolean;
  onChange: ({ id, name, value }: { id: string; name: string; value: string }) => void;
  onRemove: (id: string) => void;
  options: BaseOption[];
  placeholder?: string;
  items: ChannelBinding[];
};

export const SplitInput = ({
  errors,
  hasRemove = false,
  onChange = () => undefined,
  onRemove = () => undefined,
  options = [],
  placeholder = '',
  items = [],
}: Props) => {
  return (
    <>
      {items.map((item: { id: string; num: string; option: any }, index) => {
        const { id, num, option } = item;
        const isLast = index === items?.length - 1;

        return (
          <InputRow key={id}>
            <StyledFormField hasError={!!errors.accounts} errorText={isLast && errors.accounts}>
              <StyledSelect
                defaultValues={[option]}
                isError={!!errors.accounts && !option}
                options={options}
                onSelect={([value]) => onChange({ id, name: 'option', value: value.toString() })}
                placeholder={placeholder}
              />
            </StyledFormField>
            <StyledFormField
              hasError={!!errors.percentages}
              errorText={isLast && errors.percentages}
            >
              <InputText
                hasError={!!errors.percentages}
                id={`espAccount${id}`}
                maxValue={100}
                minValue={1}
                name={`num${id}`}
                onChange={(value) => onChange({ id, name: 'num', value })}
                Suffix="%"
                type="number"
                value={num}
              />
            </StyledFormField>
            {hasRemove && (
              <GhostButton onClick={() => onRemove(id)}>
                <Close16 />
              </GhostButton>
            )}
          </InputRow>
        );
      })}
    </>
  );
};
